export default {
  '/orders/export': '/orders/export', // done
  '/call-offs/export': '/call-offs/export', // done
  '/call-offs/notify': '/api/v1/call-offs/notify',
  '/tire-sizes/filter': '/api/v1/tire-sizes/filter',
  '/tire-sizes/filter-panel': '/api/v1/tire-sizes/filter-panel',
  '/tire-sizes/user-complaint': '/api/v1/tire-sizes/user-complaint',
  '/notices': '/api/v1/notices',
  '/tire-size/stock-notify': '/api/v1/tire-size/stock-notify',
  '/api/v1/tire-sizes/stock': '/api/v1/tire-sizes/stock',
  '/api/v1/orders/precheck': '/api/v1/orders/precheck',
  '/orders/notify': '/api/v1/orders/notify',
  '/users/verify': '/api/v1/users/verify',
  '/users/change-password': '/api/v1/users/change-password',
  '/users/shipping-addresses': '/api/v1/users/shipping-addresses',
  '/users/reset-password': '/api/v1/users/reset-password',
  '/users/feedback-questions': '/users/feedback-questions',
  '/users/export-user-answers': '/api/v1/users/export-user-answers',
  '/users/export-user-complaints': '/api/v1/users/export-user-complaints',
  '/users/update-email': '/api/v1/users/update-email',
  '/users/update-phone-number': '/api/v1/users/update-phone-number',
  '/users/set-username-password': '/api/v1/users/set-username-password',
  '/users/set-password': '/api/v1/users/set-password',
  '/users/register': '/api/v1/users/register',
  '/vouchers/verify': '/api/v1/vouchers/verify',
  '/vouchers': 'api/v1/vouchers',
  '/vouchers/validate-users': '/api/v1/vouchers/validate-users',
  '/vouchers/users': '/api/v1/vouchers/users',
};
